import React, { useEffect, useState } from 'react';
import './EventDetails.css';
import { useParams, useHistory, useLocation } from 'react-router-dom';
import NoCompanyLogo from '../Images/NoCompanyLogo.png';
import loader from '../Images/loader.gif'
import { useDispatch } from 'react-redux';
import { Button, Link, Tooltip, CircularProgress } from '@material-ui/core';
import { convertToRaw, EditorState, RichUtils, convertFromHTML, ContentState } from 'draft-js'
import TwitterIcon from '../Images/twitter.png';
import LinkedInIcon from '../Images/linkedin.webp';
import FacebookIcon from '../Images/facebook-new.png';
import WhatsappIcon from '../Images/WhatsApp_icon.png';
import InstagramIcon from '../Images/instagram-icon.webp';
import CustomAlert from './CustomAlert';
import { MetaTags } from 'react-meta-tags';
import draftToHtml from 'draftjs-to-html';
import { getSportEventDetails } from '../Backend/firebase/sport-event';
import { loadInitial } from '../Backend/firebase/events';
import DetailsSkeleton from './DetailsSkeleton';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

function AddMetaTags({ record, imageUrl }) {
    return (
        <>
            <div className="wrapper">
                <MetaTags>
                    <meta charSet="utf-8" />
                    <meta name="description" content={record?.eventName} />
                    <meta property="og:description" content={record?.eventName} />
                    <meta property="og:title" content={record?.eventName} />
                    <meta property="og:image" itemprop="image primaryImageOfPage" content={"https://kaipsoolretail.web.app/assets/kaipsool.png"} />
                    <meta property="og:image:height" content="200" />
                    <meta property="og:image:width" content="200" />
                    <meta name="twitter:description" property="og:description" content={record?.eventName} />
                    <meta name="twitter:title" content={record?.eventName} />
                    <meta name="twitter:image" content={"https://kaipsoolretail.web.app/assets/kaipsool.png"} />
                    <meta name="og:url" content={window.location.href} />
                    <title>{record?.eventName}</title>
                    <link rel="image_src" href={"https://kaipsoolretail.web.app/assets/kaipsool.png"} />
                    <link rel="canonical" href={window.location.href} />
                </MetaTags>
            </div>
        </>
    )
}


function SportEventDetails() {
    const { uid } = useParams();
    const [eventDetails, setEventDetails] = useState(null);
    const dispatch = useDispatch();
    const history = useHistory();
    const [imageUrl, setImageUrl] = useState('');
    const [openNotify, setOpenNotify] = React.useState(false);
    const [notificationMessage, setNotificationMessage] = useState('');
    const [alertType, setAlertType] = useState('');

    useEffect(() => {
        // Returns the cleanup function
        return () => {
            const metaTag = document.querySelector(`meta[content="Web site created using create-react-app"]`);
            if (metaTag) {
                metaTag.remove();
            }
        }
    }, []);

    useEffect(async () => {
        try {
            const getEventsData = await getSportEventDetails(uid);
            setEventDetails(getEventsData.event);
        } catch(error) {
            console.log("Error Occur in Get Retailer Profile", error)
        }
    }, []);

    const tournamentBooking = (tournamentId, tournamentName) => {
        console.log("tournamentName: ",tournamentName)
        history.push(`/booking-details/${tournamentId}`);
    }

    return (
        <>
            <div className="container-fluid mb-5">
                <AddMetaTags record={eventDetails} imageUrl={imageUrl} />
                {
                    eventDetails && eventDetails != null ? 
                    <div className="row">
                        <div className="col-lg-10 col-md-10 col-sm-12 mx-auto mt-5">
                            <div className="productDetail mt-5">
                                <div className="row">
                                    <div className="col-md-7">
                                        <div className="productDetail__productHead">
                                            {eventDetails?.eventImage ? <div className="eventDetail__companyInfoLogo">
                                                    <img src={eventDetails?.eventImage} alt="Store Name" className="img-fluid retailerDetail__companyInfoLogo" />
                                                </div>
                                                : <div className="retailerDetail__companyInitialLogo">
                                                    <div className="logoInitial">{loadInitial(eventDetails?.tournamentName)}</div>
                                                </div>
                                            }
                                        </div><br />
                                    </div>
                                    <div className="col-md-5">
                                        <div className="productDetail__companyInfo">
                                            {eventDetails && <h5 className="MainColor">{eventDetails?.tournamentName}</h5>}
                                            <p className="productDetail__title">By {eventDetails?.organizerName}</p>
                                            <p className="productDetail__title">Location: {eventDetails?.location}</p>
                                            <p className="productDetail__title">Event Type: {eventDetails?.eventCategory}</p>
                                            <p className="productDetail__title">Start at <b>{eventDetails?.startDate?.toDate()?.toDateString()}</b></p>
                                            <p className="productDetail__title">Last Date of Registration: <b>{eventDetails?.registrationClosingDate?.toDate()?.toDateString()}</b></p>
                                            <div className="col-md-12 mt-4">
                                                <div className="jobDetail__applyJobsShare">
                                                    <div className="jobDetail__socialIcons">
                                                        <a href={`https://wa.me/?text=${window.location.href}`} data-action="share/instagram/share" target="_blank"
                                                            style={{ marginRight: '12px' }}>
                                                            <Tooltip title="Share this post via WhatsApp" placement="top">
                                                                <img src={WhatsappIcon} alt="whatsapp-icon" width="25px" height="25px" />
                                                            </Tooltip>
                                                        </a>
                                                        {/* <a href={`https://wa.me/?text=${window.location.href}`} data-action="share/whatsapp/share" target="_blank"
                                                            style={{ marginRight: '16px' }}>
                                                            <Tooltip title="Share this post via Instagram" placement="top">
                                                                <img src={InstagramIcon} alt="instagram-icon" width="22px" height="22px" />
                                                            </Tooltip>
                                                        </a> */}
                                                        <a href={`https://www.linkedin.com/sharing/share-offsite/?url=${window.location.href}?utm_source=linkedin&utm_medium=social&utm_campaign=linkedin_social_vac_share`} target="_blank"
                                                            style={{ marginRight: '12px' }}>
                                                            <Tooltip title="Share this post via linkedIn" placement="top">
                                                                <img src={LinkedInIcon} alt="linkedin-icon" width="20px" height="20px" />
                                                            </Tooltip>
                                                        </a>
                                                        <a href={`https://www.facebook.com/sharer/sharer.php?u=${window.location.href}?utm_source=facebook&utm_medium=social&utm_campaign=facebook_social_vac_share`} target="_blank"
                                                            style={{ marginRight: '12px' }}>
                                                            <Tooltip title="Share this post via facebook" placement="top">
                                                                <img src={FacebookIcon} alt="facebook-icon" width="25px" height="25px" />
                                                            </Tooltip>
                                                        </a>
                                                        <a href={`https://twitter.com/intent/tweet?url=${window.location.href}?utm_source=twitter&utm_medium=social&utm_campaign=twitter_social_vac_share&text=${eventDetails?.tournamentName}`} target="_blank">
                                                            <Tooltip title="Share this post via twitter" placement="top">
                                                                <img src={TwitterIcon} alt="twitter-icon" width="25px" height="25px" />
                                                            </Tooltip>
                                                        </a>
                                                    </div>
                                                </div><br />
                                            </div>
                                            <div className="mt-4">
                                                <Button 
                                                    variant="contained" 
                                                    color="primary" className="navbar__btnLogin"
                                                    onClick={()=> tournamentBooking(eventDetails?.uniqueId, eventDetails?.tournamentName)}>
                                                    Register Now
                                                </Button>
                                            </div><br />
                                        </div>
                                    </div>
                                </div>
                                {(eventDetails?.aboutTheTournament && draftToHtml(JSON.parse(eventDetails?.aboutTheTournament)).length > 20) && <div className="mt-5">
                                    <div className="row jobDetail__description jobDetail__description__border">
                                        <div className="col-md-3">
                                            <h5 className="MainColor"><span className="jobDetail__descriptionHeading">About the Tournament:</span></h5>
                                        </div>
                                        <div className="col-md-9">
                                            <div dangerouslySetInnerHTML={{ __html: draftToHtml(JSON.parse(eventDetails?.aboutTheTournament)) }} />
                                        </div>
                                    </div>
                                </div>}
                                {(eventDetails?.awardsAndPrizes && draftToHtml(JSON.parse(eventDetails?.awardsAndPrizes)).length > 20) && <div className="mt-4">
                                    <div className="row jobDetail__description jobDetail__description__border">
                                        <div className="col-md-3">
                                            <h5 className="MainColor"><span className="jobDetail__descriptionHeading">Awards & Prizes:</span></h5>
                                        </div>
                                        <div className="col-md-9">
                                            <div dangerouslySetInnerHTML={{ __html: draftToHtml(JSON.parse(eventDetails?.awardsAndPrizes)) }} />
                                        </div>
                                    </div>
                                </div>}
                                {(eventDetails?.categories && draftToHtml(JSON.parse(eventDetails?.categories)).length > 20) && <div className="mt-4">
                                    <div className="row jobDetail__description jobDetail__description__border">
                                        <div className="col-md-3">
                                            <h5 className="MainColor"><span className="jobDetail__descriptionHeading">Categories:</span></h5>
                                        </div>
                                        <div className="col-md-9">
                                            <div dangerouslySetInnerHTML={{ __html: draftToHtml(JSON.parse(eventDetails?.categories)) }} />
                                        </div>
                                    </div>
                                </div>}
                                {eventDetails?.rulesAndRegulations && (draftToHtml(JSON.parse(eventDetails?.rulesAndRegulations)).length > 20) && <div className="mt-4">
                                    <div className="row jobDetail__description jobDetail__description__border">
                                        <div className="col-md-3">
                                            <h5 className="MainColor"><span className="jobDetail__descriptionHeading">Rules & Regulations:</span></h5>
                                        </div>
                                        <div className="col-md-9">
                                            <div dangerouslySetInnerHTML={{ __html: draftToHtml(JSON.parse(eventDetails?.rulesAndRegulations)) }} />
                                        </div>
                                    </div>
                                </div>}
                                {eventDetails?.eventDescription && (draftToHtml(JSON.parse(eventDetails?.eventDescription)).length > 20) && <div className="row mt-5">
                                    <div className="jobDetail__description">
                                        <h5 className="MainColor"><span className="jobDetail__descriptionHeading mb-5">Event Description</span></h5>
                                        <div dangerouslySetInnerHTML={{ __html: draftToHtml(JSON.parse(eventDetails?.eventDescription)) }} />
                                    </div>
                                </div>}
                            </div>
                        </div>
                    </div> : <div className="row">
                        <div className="col-lg-10 col-md-10 col-sm-12 mx-auto mt-5">
                            <div className="productDetail mt-5 text-center justify-center">
                                <DetailsSkeleton />
                            </div>
                        </div>
                    </div>
                }
            </div>

            <CustomAlert setOpenNotify={setOpenNotify} openNotify={openNotify} messageType={alertType}
                notificationMessage={notificationMessage} />
        </>
    )
}

export default SportEventDetails

